
import { isObject, isEmpty, isArray } from '@/utils/types';
import { valueEquals } from 'element-ui/lib/utils/util';
import Emitter from 'element-ui/lib/mixins/emitter';
export default {
  // 自定义字段库 多选
  name: 'WkCheckbox',

  components: {},

  mixins: [Emitter],

  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {},
    // 选择其他展示input输入框
    otherShowInput: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String,
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showType: {
      type: String,
      default: 'default' //  下拉 default 平铺 tiled
    }
  },

  data: function data() {
    return {
      dataValue: {
        select: [],
        otherValue: ''
      }
    };
  },


  computed: {
    valueIsObject: function valueIsObject() {
      return isObject(this.dataValue);
    }
  },

  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        this.validValue();
      },

      immediate: true
    },
    options: {
      handler: function handler() {
        this.validValue();
      },

      deep: true
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    /**
     * 验证值
     */
    validValue: function validValue() {
      var _this = this;

      if (isEmpty(this.value)) {
        this.dataValue = {
          select: [],
          otherValue: ''
        };
      } else {
        if (this.otherShowInput) {
          var value = isArray(this.value) ? this.value : [];
          var otherItem = value.filter(function (name) {
            return !_this.options.includes(name);
          });
          if (otherItem.length > 0) {
            var newValue = value.filter(function (name) {
              return !otherItem.includes(name);
            });
            newValue.push('其他');
            this.dataValue = {
              select: newValue,
              otherValue: otherItem[otherItem.length - 1]
            };
          } else {
            if (!valueEquals(value, this.dataValue.select)) {
              this.dataValue = {
                select: value,
                otherValue: ''
              };
            }
          }
        } else {
          this.dataValue = {
            select: this.value,
            otherValue: ''
          };
        }
      }
    },


    /**
     * 选项值
     */
    getValue: function getValue(item) {
      return !this.isEmptyValue(item.value) ? item.value : item;
    },


    /**
     * 判断是空值
     */
    isEmptyValue: function isEmptyValue(value) {
      return value === null || value == undefined;
    },


    /**
     * 值更新
     */
    valueChange: function valueChange() {
      if (this.dataValue.select.includes('其他')) {
        var newValue = this.dataValue.select.filter(function (item) {
          return item !== '其他';
        });
        newValue.push(this.dataValue.otherValue.trim());
        this.$emit('input', newValue);
        this.$emit('change', newValue);
        this.dispatch('ElFormItem', 'el.form.change', newValue);
      } else {
        this.dataValue.otherValue = '';
        this.$emit('input', this.dataValue.select);
        this.$emit('change', this.dataValue.select);
        this.dispatch('ElFormItem', 'el.form.change', this.dataValue.select);
      }
    },


    /**
     * 失去焦点
     */
    inputBlur: function inputBlur() {
      this.valueChange();
      // const value = this.dataValue.otherValue
      // const eIsObject = this.options.length > 0 && !this.isEmptyValue(this.options[0].value)
      // const has = this.options.find(item => {
      //   if (eIsObject) {
      //     return item.value === value.trim()
      //   } else {
      //     return item === value.trim()
      //   }
      // })
      // if (has) {
      //   this.dataValue.otherValue = ''
      // }
      // this.$emit('change', this.dataValue.select)
      // this.$emit('input', this.dataValue.select)
    }
  }
};